/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Intro_P1_BrandInputs */

const es_exp_mk_intro_p1_brand = /** @type {(inputs: Exp_Mk_Intro_P1_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiencias`)
};

const gl_exp_mk_intro_p1_brand = /** @type {(inputs: Exp_Mk_Intro_P1_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiencias`)
};

const en_exp_mk_intro_p1_brand = /** @type {(inputs: Exp_Mk_Intro_P1_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiences`)
};

/**
* | output |
* | --- |
* | "Zarpar Experiences" |
*
* @param {Exp_Mk_Intro_P1_BrandInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_intro_p1_brand = /** @type {((inputs?: Exp_Mk_Intro_P1_BrandInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Intro_P1_BrandInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_intro_p1_brand(inputs)
	if (locale === "en") return en_exp_mk_intro_p1_brand(inputs)
	return es_exp_mk_intro_p1_brand(inputs)
});